// extracted by mini-css-extract-plugin
export default {"logo":"PMPixelLogo_logo__LvzxD","img":"PMPixelLogo_img__QzWAg","small":"PMPixelLogo_small__RBk8V","medium":"PMPixelLogo_medium__-2URL","large":"PMPixelLogo_large__8oBef"};